<div class="modal-header">
  <div style="display: flex; justify-content: space-between; width: 100%;">
    <h4 class="modal-title">
        <b>{{ "comparator.title" | translate }}</b> - 
        <span style="font-size: 16px;">
            {{ locations.length }} 
            {{ "comparator.subtitle" | translate }}
        </span>
    </h4>
    <app-date-range-picker
        [form]="formFilter | asFormGroup"
        inputFormControlName="date"
    ></app-date-range-picker>
  </div>
</div>
<div class="modal-body">
    <div *ngIf="loading">
        <ng-container style="float: right" class="flex">
            <div class="loader-box">
            <div class="loader-34"></div>
            </div>
            <h6 class="col align-self-center f-w-600" style="text-align: center">
            {{ "fetching" | translate }}
            </h6>
        </ng-container>
    </div>
    <div class="table-responsive data-table" style="position: initial" *ngIf="!loading">
        <form>
            <table class="table table-striped table-border-vertical">
                <thead>
                    <tr>
                        <th> {{ "comparator.table.locations" | translate }}</th>
                        <ng-container *ngFor="let location of locationRankingPerImpression">
                            <th>
                                <b>{{ location }}</b>
                            </th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ "comparator.table.impressionsTotal" | translate }}</td>
                        <td *ngFor="let location of locationRankingPerImpression" style="justify-items: center;">
                            <div style="display: flex; align-items: center; justify-content: flex-start">
                                <!-- <img src="assets/svgIcon/indicator.svg" style="margin-right: 4px;"/>  -->
                                 <div [ngClass]="'dot rank-' + getRankClass(location, 'impressions')"></div>
                                <div [ngClass]="getRankClass(location, 'impressions') === 0 ? 'bold' : ''">{{ locationsStats[location].impressions }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "comparator.table.usersTotal" | translate }}</td>
                        <td *ngFor="let location of locationRankingPerImpression" style="justify-items: center;">
                            <div style="display: flex; align-items: center; justify-content: flex-start">
                                <!-- <img src="assets/svgIcon/indicator.svg" style="margin-right: 4px;"/>  -->
                                 <div [ngClass]="'dot rank-' + getRankClass(location, 'consumers')"></div>
                                <div [ngClass]="getRankClass(location, 'consumers') === 0 ? 'bold' : ''">{{ locationsStats[location].consumers }}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="closeModal()">
    {{ "buttons.close" | translate }}
  </button>
</div>
